import imagePaths from "../../../constants/imagePaths";

const { common } = imagePaths;

export const getCountry = (selectedCountryCode) => {
  switch (selectedCountryCode) {
    case "id":
    case "idic":
      return common.countryFlags.indonesia;
    case "vn":
      return common.countryFlags.vietnam;
    case "ph":
      return common.countryFlags.philippines;
    case "pk":
      return common.countryFlags.pakistan;
    case "bd":
      return common.countryFlags.bangladesh;
    case "kh":
      return common.countryFlags.cambodia;
    case "la":
      return common.countryFlags.laos;
    case "my":
      return common.countryFlags.malaysia;
    default:
      return common.countryFlags.thailand;
  }
};

export const getCountryName = (selectedCountryCode, isHPC) => {
  if (selectedCountryCode === "id") {
    return isHPC ? "Indonesia HPC" : "Indonesia";
  }
  switch (selectedCountryCode) {
    case "idic":
      return "Indonesia IC";
    case "vn":
      return "Vietnam";
    case "ph":
      return "Philippines";
    case "pk":
      return "Pakistan";
    case "bd":
      return "Bangladesh";
    case "kh":
      return "Cambodia";
    case "la":
      return "Laos";
    case "my":
      return "Malaysia";
    default:
      return "Thailand";
  }
};
